import EmailAddress from "_shared/email-addresses/email-address";
import Guid from "_shared/guids/guid";
import IndividualSummary from "marketplace/individuals/profiles/summaries/individual-summary";

export default class IndividualSummaryAPIResponse {
  public id?: string;
  public userId?: string;
  public firstName?: string;
  public lastName?: string;
  public avatar?: string;
  public email?: string;

  public deserialize(): IndividualSummary {
    if (!this.id) throw new Error("Individual Summary ID not returned from API");
    if (!this.userId) throw new Error("Individual Summary User ID not returned from API");

    if (!this.firstName) throw new Error("Individual Summary First Name not returned from API");
    if (!this.lastName) throw new Error("Individual Summary Last Name not returned from API");

    return new IndividualSummary(
      new Guid(this.id),
      new Guid(this.userId),
      this.firstName,
      this.lastName,
      this.avatar ? new Guid(this.avatar) : undefined,
      this.email ? new EmailAddress(this.email) : undefined
    );
  }
}
